import { SearchFilterAction, SET_SEARCH } from './search-actions';

export function searchReducer(searchFilterText = '', action: SearchFilterAction): string {
  if (action.type === SET_SEARCH) {
    return action.searchFilterText;
  }
  return searchFilterText;
}
